import React from 'react';
import FirebaseTable from '../../../components/FirebaseTable';
import moment from 'moment';
import unwrap from '../../../functions/unwrap';

export default function All() {
  return (
    <FirebaseTable
      title="API Events"
      path="events"
      limitToLast={500}
      observe
      reverse
      link={event => `/admin/events/${event.key}`}
      linkTitle={event => JSON.stringify(event, null, '\t')}
      columns={[
        {heading: 'Method', value: event => event.method},
        {heading: 'Path', value: event => event.path},
        {
          heading: 'Time',
          value: event => moment(event.timestampMs).calendar(),
        },
        {
          heading: 'Duration (seconds)',
          value: event =>
            unwrap(event.responseDurationS, duration =>
              duration < 5 ? (
                duration
              ) : duration < 15 ? (
                <span className="text-warning">{duration}</span>
              ) : (
                <span className="text-danger">{duration}</span>
              ),
            ),
        },
        {
          heading: 'Response',
          value: event => {
            if (event.responseCode >= 200 && event.responseCode < 300) {
              return (
                <span className="text-success">
                  {event.responseCode} {event.responseText}
                </span>
              );
            } else {
              return (
                <span className="text-danger">
                  {event.responseCode} {event.responseText}
                </span>
              );
            }
          },
        },
      ]}
    />
  );
}
